import { OnInit } from '@angular/core';
import { ButtonViewComponent } from './button-renderer-crypto';

export class DownloadRendererCrypto extends ButtonViewComponent implements OnInit {
  ngOnInit() {
    super.ngOnInit();
    this.renderValue = null;
    this.renderIcon = 'nb-play';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/renderer-crypto/download-renderer-crypto.ts